import React from "react";

const Preloader = () => {
  return (
    <div id="preloader">
      <div id="restan-preloader" className="restan-preloader">
        <div className="animation-preloader">
          <div className="spinner"></div>
        </div>
        <div className="loader">
          <div className="row">
            <div className="col-3 loader-section section-left">
              <div className="bg"></div>
            </div>
            <div className="col-3 loader-section section-left">
              <div className="bg"></div>
            </div>
            <div className="col-3 loader-section section-right">
              <div className="bg"></div>
            </div>
            <div className="col-3 loader-section section-right">
              <div className="bg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
